export enum EAxiosResponseType {
  ARRAY_BUFFER = `arraybuffer`,
  BLOB = `blob`,
  DOCUMENT = `document`,
  JSON = `json`,
  STREAM = `stream`,
  TEXT = `text`,
}

export enum EProductSliderType {
  SQUARE = `square`,
  BORDERLESS = `borderless`,
}

export enum ESwalType {
  WARNING = `warning`,
  ERROR = `error`,
  INFO = `info`,
  SUCCESS = `success`,
  QUESTION = `question`,
}

export enum EArrowDirection {
  DOWN = `down`,
  LEFT = `left`,
  RIGHT = `right`,
  UP = `up`,
}

export enum ETimeUnit {
  MINUTE = `minute`,
  SECOND = `second`,
}
